import { MonthlyPrayerTimes } from '../types';

export const mayPrayerTimes: MonthlyPrayerTimes = {
  1: {
    fajr: "03:06",
    shoruk: "04:42",
    dhuhr: "12:50",
    asr: "16:59",
    maghrib: "20:48",
    isha: "22:13"
  },
  2: {
    fajr: "03:04",
    shoruk: "04:40",
    dhuhr: "12:50",
    asr: "17:00",
    maghrib: "20:50",
    isha: "22:15"
  },
  3: {
    fajr: "03:03",
    shoruk: "04:37",
    dhuhr: "12:50",
    asr: "17:01",
    maghrib: "20:53",
    isha: "22:16"
  },
  4: {
    fajr: "03:01",
    shoruk: "04:34",
    dhuhr: "12:50",
    asr: "17:02",
    maghrib: "20:55",
    isha: "22:18"
  },
  5: {
    fajr: "03:00",
    shoruk: "04:32",
    dhuhr: "12:50",
    asr: "17:03",
    maghrib: "20:57",
    isha: "22:19"
  },
  6: {
    fajr: "02:58",
    shoruk: "04:29",
    dhuhr: "12:50",
    asr: "17:04",
    maghrib: "21:00",
    isha: "22:21"
  },
  7: {
    fajr: "02:57",
    shoruk: "04:27",
    dhuhr: "12:49",
    asr: "17:05",
    maghrib: "21:02",
    isha: "22:22"
  },
  8: {
    fajr: "02:55",
    shoruk: "04:24",
    dhuhr: "12:49",
    asr: "17:06",
    maghrib: "21:04",
    isha: "22:24"
  },
  9: {
    fajr: "02:54",
    shoruk: "04:22",
    dhuhr: "12:49",
    asr: "17:07",
    maghrib: "21:07",
    isha: "22:25"
  },
  10: {
    fajr: "02:52",
    shoruk: "04:19",
    dhuhr: "12:49",
    asr: "17:08",
    maghrib: "21:09",
    isha: "22:27"
  },
  11: {
    fajr: "02:51",
    shoruk: "04:17",
    dhuhr: "12:49",
    asr: "17:08",
    maghrib: "21:11",
    isha: "22:28"
  },
  12: {
    fajr: "02:49",
    shoruk: "04:15",
    dhuhr: "12:49",
    asr: "17:09",
    maghrib: "21:14",
    isha: "22:30"
  },
  13: {
    fajr: "02:48",
    shoruk: "04:12",
    dhuhr: "12:49",
    asr: "17:10",
    maghrib: "21:16",
    isha: "22:31"
  },
  14: {
    fajr: "02:47",
    shoruk: "04:10",
    dhuhr: "12:49",
    asr: "17:11",
    maghrib: "21:18",
    isha: "22:32"
  },
  15: {
    fajr: "02:45",
    shoruk: "04:08",
    dhuhr: "12:49",
    asr: "17:12",
    maghrib: "21:21",
    isha: "22:34"
  },
  16: {
    fajr: "02:44",
    shoruk: "04:06",
    dhuhr: "12:49",
    asr: "17:13",
    maghrib: "21:23",
    isha: "22:35"
  },
  17: {
    fajr: "02:43",
    shoruk: "04:03",
    dhuhr: "12:49",
    asr: "17:14",
    maghrib: "21:25",
    isha: "22:37"
  },
  18: {
    fajr: "02:41",
    shoruk: "04:01",
    dhuhr: "12:49",
    asr: "17:15",
    maghrib: "21:27",
    isha: "22:38"
  },
  19: {
    fajr: "02:40",
    shoruk: "03:59",
    dhuhr: "12:49",
    asr: "17:15",
    maghrib: "21:30",
    isha: "22:40"
  },
  20: {
    fajr: "02:39",
    shoruk: "03:57",
    dhuhr: "12:49",
    asr: "17:16",
    maghrib: "21:32",
    isha: "22:41"
  },
  21: {
    fajr: "02:38",
    shoruk: "03:55",
    dhuhr: "12:49",
    asr: "17:17",
    maghrib: "21:34",
    isha: "22:42"
  },
  22: {
    fajr: "02:37",
    shoruk: "03:53",
    dhuhr: "12:50",
    asr: "17:18",
    maghrib: "21:36",
    isha: "22:44"
  },
  23: {
    fajr: "02:36",
    shoruk: "03:51",
    dhuhr: "12:50",
    asr: "17:19",
    maghrib: "21:38",
    isha: "22:45"
  },
  24: {
    fajr: "02:35",
    shoruk: "03:49",
    dhuhr: "12:50",
    asr: "17:19",
    maghrib: "21:40",
    isha: "22:47"
  },
  25: {
    fajr: "02:34",
    shoruk: "03:48",
    dhuhr: "12:50",
    asr: "17:20",
    maghrib: "21:42",
    isha: "22:48"
  },
  26: {
    fajr: "02:32",
    shoruk: "03:46",
    dhuhr: "12:50",
    asr: "17:21",
    maghrib: "21:44",
    isha: "22:49"
  },
  27: {
    fajr: "02:32",
    shoruk: "03:44",
    dhuhr: "12:50",
    asr: "17:22",
    maghrib: "21:46",
    isha: "22:50"
  },
  28: {
    fajr: "02:31",
    shoruk: "03:42",
    dhuhr: "12:50",
    asr: "17:22",
    maghrib: "21:48",
    isha: "22:52"
  },
  29: {
    fajr: "02:30",
    shoruk: "03:41",
    dhuhr: "12:50",
    asr: "17:23",
    maghrib: "21:50",
    isha: "22:53"
  },
  30: {
    fajr: "02:29",
    shoruk: "03:39",
    dhuhr: "12:50",
    asr: "17:24",
    maghrib: "21:52",
    isha: "22:54"
  },
  31: {
    fajr: "02:28",
    shoruk: "03:38",
    dhuhr: "12:51",
    asr: "17:24",
    maghrib: "21:53",
    isha: "22:55"
  }
};